export const ROW_TYPE = {
  SCOPE: "scope",
  TASK_GROUP: "taskGroup",
  TASK: "task",
};

// Flagged rows first, then earliest start date first. Applied within each
// sibling list (scopes, task groups, tasks) independently.
export const compareByFlagAndStartDate = (a, b) => {
  const flagDiff = (b.isFlagged ? 1 : 0) - (a.isFlagged ? 1 : 0);
  if (flagDiff !== 0) return flagDiff;
  const aTime = a.startDate ? new Date(a.startDate).getTime() : Infinity;
  const bTime = b.startDate ? new Date(b.startDate).getTime() : Infinity;
  return aTime - bTime;
};

// ScopeTaskBreakdownDto already groups tasks server-side: { scopeId, taskGroups: TaskGroupWithTasksDto[], standaloneTasks: TasksDto[] }.
// Task groups render first, standalone tasks as siblings at the same depth;
// each sibling list is sorted flagged-first-then-startDate.
export const buildScopeTreeFromBreakdown = (breakdown) => {
  if (!breakdown) return [];

  const taskGroupRows = (breakdown.taskGroups || [])
    .map((group) => ({
      ...group,
      rowType: ROW_TYPE.TASK_GROUP,
      // TaskGroupWithTasksDto exposes `taskCount`; normalized to `tasksCount`
      // so the Scope table's existing "Tasks" column cell works unmodified.
      tasksCount: group.taskCount,
      subRows: (group.tasks || [])
        .map((task) => ({ ...task, rowType: ROW_TYPE.TASK }))
        .sort(compareByFlagAndStartDate),
    }))
    .sort(compareByFlagAndStartDate);

  const standaloneTaskRows = (breakdown.standaloneTasks || [])
    .map((task) => ({ ...task, rowType: ROW_TYPE.TASK }))
    .sort(compareByFlagAndStartDate);

  return [...taskGroupRows, ...standaloneTaskRows];
};

// ScopeSearchBreakdownDto is self-contained (unlike ScopeTaskBreakdownDto): it
// carries the matched scope's own display fields alongside its pruned
// taskGroups/standaloneTasks, since a match can surface a scope that was
// never loaded from the paginated list. Each entry becomes a full scope row.
export const buildScopeTreeFromSearchResults = (searchResults) =>
  (searchResults || []).map((result) => ({
    ...result.scope,
    rowType: ROW_TYPE.SCOPE,
    subRows: buildScopeTreeFromBreakdown(result),
  }));
